import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { compose, getContext, withProps } from 'recompose'

import { FlowRoute } from 'utils/FlowProvider/types'

import { CORE_HERO_COPY } from './coreCopy'
import { DIRECT_TO_MOBILE_HERO_COPY } from './directToMobileCopy'
import { LATER_HERO_COPY } from './laterCopy'
import { MOC_ONBOARDING_HERO_COPY } from './mocOnboardingCopy'
import { SPEND_HERO_COPY } from './spendCopy'
import { TIERED_HERO_COPY } from './tieredCopy'

type Props = {
  heroText: HeroText
}

type HeroText = {
  header: string
  text: string
  subtext?: string
  footnote?: string
  mobileFootnote?: string
  footnoteLock?: boolean
  footerText?: string
  veteranText?: string
  veteranSubtext?: string
  veteranCaption?: string
}

export type HeroTextProps = Props

export const getHeroText = (flow: string, path: string) => {
  switch (flow.toLowerCase()) {
    case 'core':
      return CORE_HERO_COPY.get(path)
    case 'later':
      return LATER_HERO_COPY.get(path)
    case 'spend':
      return SPEND_HERO_COPY.get(path)
    case 'directtomobile':
      return DIRECT_TO_MOBILE_HERO_COPY.get(path)
    case 'mightyoakcardonboarding':
      return MOC_ONBOARDING_HERO_COPY.get(path)
    default:
      return TIERED_HERO_COPY.get(path)
  }
}

export const removeTrailingSlash = pathname => {
  return pathname && pathname.endsWith(FlowRoute.Welcome)
    ? pathname.slice(0, pathname.length - 1)
    : pathname
}

export default compose<Props, {}>(
  getContext({
    flow: PropTypes.string,
  }),
  withRouter,
  withProps(({ history, flow }) => {
    const pathname = removeTrailingSlash(history.location.pathname)
    return {
      heroText: getHeroText(flow, pathname),
    }
  }),
)
